import { forwardRef } from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

import {
  RadioGroupIndicator,
} from "@/ui/components/form/RadioGroup/RadioGroupIndicator";
import {
  type TRadioGroupItemElement,
  type TRadioGroupItemProps,
} from "@/ui/components/form/RadioGroup/RadioGroup.config";
import { cn } from "@/ui/lib/utils";

export const RadioGroupItem = forwardRef<TRadioGroupItemElement, TRadioGroupItemProps>(
  (
    {
      className,
      children,
      ...props
    },
    ref,
  ) => (
    <RadioGroupPrimitive.Item
      {...props}
      ref={ref}
      data-component="RadioGroupItem"
      className={cn(
        "peer col-start-1 row-start-1 self-center",
        "flex h-4 w-4 items-center justify-center rounded-full border border-solid border-component-checkbox-check-unchecked bg-component-checkbox-check-unchecked shadow-sm",
        "transition-colors ease-in-out duration-200",
        "data-[state=checked]:border-component-checkbox-check-checked data-[state=checked]:bg-component-checkbox-check-unchecked",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sys-chartreuse-600",
        "disabled:opacity-50",
        className,
      )}
    >
      { children ?? <RadioGroupIndicator /> }
    </RadioGroupPrimitive.Item>
  ),
);

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;
